import { useState, useEffect } from "react";
import { Bar } from "react-chartjs-2";
// Constants
// import { graphicDataColor1 } from "../../../../../../config/constants";
// Components
import { MainDiv, Header, Title, OpenButton, OpenButtonImg } from "./styles";
import Graphic from "../../../../../graphic";
import NoDataComponent from "../../../noDataComponent";
// Assets
import ArrowUpImg from "../../../../../../assets/icons/ico_arrow_up_blue.svg";
import ArrowDownImg from "../../../../../../assets/icons/ico_arrow_down_blue.svg";

const RecoveryClassificationPlot = ({ prognosisData }) => {
  const [showPlot, setShowPlot] = useState(false);
  const [classificationDataset, setClassificationDataset] = useState({});

  // Set dataset
  useEffect(() => {
    const findMetric = (key) => prognosisData.find((prognosisInput) => prognosisInput.PROGNOSIS_PREDICTION_KEY === key);
    const excellentMetric = findMetric("Excellent, quick recovery");
    const goodQuickMetric = findMetric("Good, quick recovery");
    const goodSlowMetric = findMetric("Good, slow recovery");
    const moderateMetric = findMetric("Moderate, slow recovery");
    const poorMetric = findMetric("Poor recovery");

    const metricsArray = [
      excellentMetric?.PROGNOSIS_PREDICTION_VALUE ? Math.round(Number(excellentMetric.PROGNOSIS_PREDICTION_VALUE) * 100) : 0,
      goodQuickMetric?.PROGNOSIS_PREDICTION_VALUE ? Math.round(Number(goodQuickMetric.PROGNOSIS_PREDICTION_VALUE) * 100) : 0,
      goodSlowMetric?.PROGNOSIS_PREDICTION_VALUE ? Math.round(Number(goodSlowMetric.PROGNOSIS_PREDICTION_VALUE) * 100) : 0,
      moderateMetric?.PROGNOSIS_PREDICTION_VALUE ? Math.round(Number(moderateMetric.PROGNOSIS_PREDICTION_VALUE) * 100) : 0,
      poorMetric?.PROGNOSIS_PREDICTION_VALUE ? Math.round(Number(poorMetric.PROGNOSIS_PREDICTION_VALUE) * 100) : 0,
    ];

    const predictedTrajectoryData = {
      labels: ["Excellent", "Good (quick)", "Good (slow)", "Moderate", "Poor"],
      datasets: [
        {
          label: [],
          data: metricsArray,
          backgroundColor: [
            "rgba(34, 181, 115, 1)",
            "rgba(36, 175, 149, 1)",
            "rgba(38, 169, 182, 1)",
            "rgba(247, 147, 30, 1)",
            "rgba(224, 102, 102, 1)",
          ],
          borderWidth: 1,
        },
      ],
    };

    setClassificationDataset(predictedTrajectoryData);

    return () => {
      setClassificationDataset({});
    };
  }, [prognosisData]);

  return (
    <MainDiv>
      <Header>
        <Title>Patient recovery classification</Title>
        <OpenButton onClick={() => setShowPlot(!showPlot)}>
          <OpenButtonImg src={showPlot ? ArrowUpImg : ArrowDownImg} alt="arrow-ico" />
        </OpenButton>
      </Header>
      {showPlot &&
        (Boolean(prognosisData.length) ? (
          <Graphic
            Title={""}
            Type={Bar}
            data={classificationDataset}
            axisY={""}
            axisX={"Probability of Belonging to a specific recovery Class (%)"}
            max={100}
            margin="0"
            height="250px"
            showLegend={false}
            indexAxis="y"
          />
        ) : (
          <NoDataComponent />
        ))}
    </MainDiv>
  );
};

export default RecoveryClassificationPlot;
